import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addPermissions, deletePermissions, getModulesList, getPermissionsList, updatePermissions } from "api/permissions.api";
import { notificationController } from "controllers/notificationController";
import { IModuleList, IPermissionData, IPermissionResponse, Modules, Permissions, PermissionsRequest } from "domain/Permissions";

export interface PermissionsSlice {
    permissionsList: Permissions[] | null;
    moduleList: Modules[] | null;
}

const initialState: PermissionsSlice = {
  permissionsList: null,
  moduleList: null,
};

export const doGetPermissions = createAsyncThunk(
  "permissions/doGetPermissions",
  async () =>
    getPermissionsList().then((res: IPermissionResponse) => {
      return res;
    })
);

export const doGetModules = createAsyncThunk(
  "permissions/doGetModules",
  async () =>
    getModulesList().then((res: IModuleList) => {
      return res;
    })
);

export const doAddPermissions = createAsyncThunk(
  "permissions/doAddPermission",
  async (professionalPayload: PermissionsRequest, { dispatch }) =>
    addPermissions(professionalPayload).then((res) => {
      dispatch(doGetPermissions());
      return res;
    })
);
export const doUpdatePermissions = createAsyncThunk(
  "permissions/doUpdatePermission",
  async (professionalPayload: IPermissionData, { dispatch }) =>
    updatePermissions(professionalPayload.id as string, professionalPayload).then((res) => {
      dispatch(doGetPermissions());
      return res;
    })
);

export const doDeletePermissions = createAsyncThunk(
  "permissions/doDeletePermission",
  async (roleId: string, { dispatch }) => {
    deletePermissions(roleId).then(
      (res) => {
        notificationController.error({
          message: "Role Deleted successfully.",
        });
        dispatch(doGetPermissions());
        return res;
      },
      (error) => {
        notificationController.error({
          message: error.toString(),
        });
      }
    );
  }
);

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetPermissions.fulfilled, (state, action) => {
      state.permissionsList = action.payload.data;
    });
    builder.addCase(doGetModules.fulfilled, (state, action) => {
      state.moduleList = action.payload.data;
    });
  },
});

export default permissionsSlice.reducer;